import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, RouteProps } from 'react-router-dom';
import { WebRoutes } from '../../enums/routerPath';
import { RootState } from '../../store/rootReducer';
import { IPageProps, Page } from '../page';

export interface IPaymentFailedRouteProps extends RouteProps {
	redirectPath?: string;
}

export const PaymentFailedRoute: React.FC<IPaymentFailedRouteProps & IPageProps> = ({ title, redirectPath, component, ...props }) => {
	const paymentFailed = useSelector((state: RootState) => state.paymentForm.paymentFailure);

	return paymentFailed ? <Page title={title} {...props} component={component} /> : <Redirect to={redirectPath ?? WebRoutes.HOME.path} />;
};
